import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es')

/** *
* *Generates Concursant reports
@param conc Concurants data
@param action defines if it saves it or dislpays it
*/
const generatePDFConc = (conc,action) => {//
  // initialize jsPDF
  const doc = new jsPDF();

  // define the columns we want and their titles
  const tableColumn = ["Nombre", "Email", "País"];
  // define an empty array of rows
  const tableRows = [];

  // for each conc pass all its data into an array
  conc.forEach(c => {
    const concData = [
      c.name,
      c.email,
      c.country,
    ];
    tableRows.push(concData);
  });

  // startY is basically margin-top
  const date = Date().split(" ");
  // we use a date string to generate our filename.
  const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];

  // we define the name of our PDF file.
  var today = moment(Date.now())
  today.locale('es')
  doc.text(`Premio Casa de las Americas 2022`, 55, 15);
  doc.text(`${today.format('LL')}`, 80, 25);
  doc.text("Reporte de Concursantes", 8, 30);
  doc.autoTable(tableColumn, tableRows, { startY: 35 });

  if(action === "save"){
    doc.save(`reporte_conc_${dateStr}.pdf`);
  }
  else{
    doc.setProperties({
      title: `reporte_conc_${dateStr}.pdf`
      });
      doc.output('dataurlnewwindow');
  }
};
export default generatePDFConc;